// extracted by mini-css-extract-plugin
module.exports = {"PokemonList":"EvolutionChains_PokemonList__2vX3o","loading":"EvolutionChains_loading__3KsUx"};